// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","315":"255c9237","513":"a97664bc","625":"84efc53e","706":"cc727622"}[chunkId] + ".chunk.js";
};